import { TeklifKalem } from "./teklif-kalem";

export class SiparisKalem {
    id:number;
    siparisId: number;
    teklifKalemId: number;
    miktar: number;
    cariId: number;
    teklifKalem: TeklifKalem;
    
  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }
}
